export const ACTION_AFTER_VIEWED_TIMEOUT = 1000;
